module.exports = __webpack_public_path__ + "img/el-ic-face.2e120819.svg";